import { createFileRoute } from "@tanstack/react-router";
import { LogUserPage } from "@/components/admin/ai-assistant/log-user-page";

export const Route = createFileRoute("/admin/ai-assistant/log/$userId/")({
	component: LogUserPage,
});
